import PropTypes from 'prop-types';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import CountriesListData from './CountriesListData';
import CountriesListBody from './CountriesListBody';

const Edit = (props) => {
  const { data, block, selected } = props;

  return (
    <>
      <CountriesListBody data={data} id={block} isEditMode />
      <SidebarPortal selected={selected}>
        <CountriesListData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
